// extracted by mini-css-extract-plugin
module.exports = {"list":"DetailsList_list__3_XFI","item":"DetailsList_item__bG3dj","content":"DetailsList_content__2P2X0"};